/** @jsxRuntime classic */
/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
const React = require('react');
const { Helmet } = require('react-helmet-async');
const { useLocation } = require('react-router-dom');
const { SITE_BASE_URL } = require('../site/siteRoutes');
const publicPageSeo = require('../site/publicPageSeo');

function NoindexRouteSeo() {
  const { pathname } = useLocation();
  // CourseSeo owns both canonical metadata and robots for course/review surfaces.
  // React 19 hoists sibling Helmet tags without deduplicating conflicting owners.
  // The two static challenge steps also own their metadata in their own page;
  // they are listed as noindex routes only so crawlers get their own document.
  if (
    pathname.startsWith('/courses/ai-trading-bootcamp') ||
    pathname.startsWith('/courses-clarity') ||
    pathname === '/challenges/welcome' ||
    pathname === '/challenges/call-confirmed' ||
    pathname.startsWith('/posts/')
  )
    return null;
  if (window.location.hostname.toLowerCase() === 'dev.botspot.trade') {
    return (
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
    );
  }
  if (!publicPageSeo.isNoindexPath(pathname)) return null;
  const route = publicPageSeo.getNoindexRoute(pathname);
  if (!route) return null;
  const canonical = `${SITE_BASE_URL}${route.path}`;

  return (
    <Helmet>
      <title>{route.title}</title>
      <meta name="description" content={route.description} />
      <meta name="robots" content={route.robots || 'noindex, follow'} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

module.exports = NoindexRouteSeo;
